const BackTop = (a) => {
    var str = a || false;
    if (!a) {
        a = 0
    }
    document.body.scrollTop = a;
    document.documentElement.scrollTop = a;
};
export default BackTop;


// WEBPACK FOOTER //
// ./src/utils/BackTop.js